{
  "title": "autobrr",
  "username": "Benutzername",
  "password": "Passwort",
  "confirmPassword": "Passwort bestätigen",
  "createAccount": "Konto erstellen",
  "rememberMe": "Angemeldet bleiben",
  "forgotPassword": "Passwort vergessen?",
  "forgotPasswordHelp": "Zurücksetzen über Terminal:",
  "signIn": "Anmelden",
  "continueWith": "Oder weiter mit",
  "openidConnect": "OpenID Connect",
  "errors": {
    "required": "Pflichtfeld",
    "usernameRequired": "Benutzername ist erforderlich",
    "passwordRequired": "Passwort ist erforderlich",
    "passwordsDoNotMatch": "Passwörter stimmen nicht überein!",
    "generic": "Ein Fehler ist aufgetreten!",
    "oidcFailed": "OIDC-Authentifizierung fehlgeschlagen"
  }
}
